import React from 'react'
import pipes from "../img/pipes.jpg"
import '../styles/About.css'

const About = () => {
    return(

        <div className = "about"> 

            <div>
                <img className = "about-img" src = {pipes} alt = "water"/>
            </div>

            <div className = "about-div">

                <h1 className = "section-header">About Us</h1>
                               
                <img className= "stucko-img"src= "https://images.unsplash.com/photo-1545262722-9e0d80a0bc01?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt = "stucko"/>

                <p>Stucko was founded in 1986 by "Big Joe" Stucko. Stucko was a small family ran operation until the early 1990's, until "Big Joe decided to franchise out.</p> 
                
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum delectus porro libero voluptatem quam eos ipsa recusandae qui, error quisquam, inventore exercitationem, incidunt minus rerum consequatur ex molestias? Delectus, placeat?</p>

                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum delectus porro libero voluptatem quam eos ipsa recusandae qui, error quisquam, inventore exercitationem, incidunt minus rerum consequatur ex molestias? Delectus, placeat?Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum delectus porro libero voluptatem quam eos ipsa recusandae qui, error quisquam, inventore exercitationem, incidunt minus rerum consequatur ex molestias? Delectus, placeat?</p>

            </div> 
                       
        </div>
    )
}

export default About